import _axios from "axios"
import store from "../../store"
const OVERRIDE_SERVER = process.env.REACT_APP_OVERRIDE_SERVER;
class AxiosInterface {
  send(arg1, arg2) {
    let request = arg1
    if (typeof request === "string") {
      request = { url: arg1, ...(arg2 || {}) }
    }

    const token = request?.token || store?.user?.token
    const axios = _axios.create()

    axios.interceptors.request.use((req) => onRequest(req, token))
    axios.interceptors.response.use(onSuccess, request?.handleError || onError)

    return axios(request)
  }

  get(request) {
    return this.send({ method: "GET", ...request })
  }

  post(request) {
    return this.send({ method: "POST", ...request })
  }

  patch(request) {
    return this.send({ method: "PATCH", ...request })
  }

  delete(request) {
    return this.send({ method: "DELETE", ...request })
  }

  upload(url, file, request = {}) {
    const headers = { "Content-Type": "multipart/form-data" }
    const data = new FormData()

    const fileName = request?.fileName
    const payload = request?.payload

    data.append("upload", file)
    if (fileName) data.append("name", fileName)

    if (payload) {
      for (const key in payload) {
        data.append(key, payload[key])
      }
    }

    return this.send({ method: "POST", url, data, headers })
  }
}

function onRequest(request, token) {
  const HOSTS = {
    "my.salusion.com": "https://backend.salusion.com/v1/",
    "my.salusion-staging.com": "https://backend.salusion-staging.com/v1/",
    "my.salusion-preprod.com": "https://backend.salusion-preprod.com/v1/",
    "my.salusion-production.com": "https://backend.salusion-production.com/v1/",
  }

  const hostname = window.location.hostname
  let HOST = HOSTS[hostname]
  // if (process.env.CODESPACE_ACCOUNT?.toUpperCase() === "TRUE") {
  //   HOST = HOSTS["my.salusion-staging.com"]
  // }
  const salusionURL = HOST || OVERRIDE_SERVER || "https://backend.salusion.com/v1/"

  if (!request.url.includes(salusionURL)) {
    if (request.url.startsWith("/")) {
      request.url = salusionURL + request.url.slice(1)
    } else {
      request.url = salusionURL + request.url
    }
  }

  if (token) request.headers.authorization = `Bearer ${token}`
  if (Boolean(OVERRIDE_SERVER)) request.headers["x-env"] = "x-env"

  return request
}

function onSuccess(response) {
  return response
}

function onError(error) {
  const errorCode = error?.response?.data?.code
  const errorMessage = error?.response?.data?.message

  const enrollment = window.location.pathname.includes("enrollment")
  const customerView = store?.user?.isSeanOrCustomer

  if (errorCode === "101-02") {
    if (enrollment) return new Error()
    return store.invalidateUser({})
  }

  if (errorMessage) {
    store.setNotification("notification", true, {
      msg: errorMessage,
      severity: "error",
    })
  }
  if (!errorCode && customerView) window.location.href = "/error"

  return Promise.reject(error)
}

export const axiosWrapperV2 = new AxiosInterface()

export default class APIWrapper {
  constructor(attributes) {
    Object.assign(this, attributes)
    this.postInit(attributes)
  }

  postInit(attributes) {
    return
  }

  set(attributes) {
    Object.assign(this, attributes)
    return this
  }
}
